import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  role: "status",
  class: "inline-flex items-center gap-2 text-sm text-muted-foreground"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "sr-only"
}

import { LoaderCircle } from '@lucide/vue';
import type { HTMLAttributes } from 'vue';
import { cn } from '@/lib/utils';

export default /*@__PURE__*/_defineComponent({
  __name: 'Spinner',
  props: {
    class: {},
    label: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createVNode(_unref(LoaderCircle), {
      class: _normalizeClass(_unref(cn)('size-4 animate-spin', props.class)),
      "aria-hidden": "true"
    }, null, 8, ["class"]),
    (__props.label)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.label), 1))
      : (_openBlock(), _createElementBlock("span", _hoisted_3, "Загрузка"))
  ]))
}
}

})